<template>
  <div>
    <div class="block shippingSelect">
      <div class="shippingDiv shipping_md" :class="{ 'shipping_selected' : shipping_type === 'MD' }"
           @click="shippingTypeChange('MD')">
        <span><img :src="require('@/assets/img/order/MD.png')"></span>
        <span>
          {{$t('mall_confirm_order.md')}}<!-- 門店自取 -->
        </span>
        <span>
         {{$t('mall_confirm_order.md_tips')}} <!-- （費用全免·尊貴體驗） -->
        </span>
      </div>
      <div class="shippingDiv shipping_yj" :class="{ 'shipping_selected' : shipping_type === 'YJ' }"
           @click="shippingTypeChange('YJ')">
        <span><img :src="require('@/assets/img/order/YJ.png')"></span>
        <span>
          {{$t('mall_confirm_order.zt')}}<!-- 預約自取  -->
        </span>
        <span>
         {{$t('mall_confirm_order.zt_tips')}} <!-- （辦公室、港鐵站） -->
        </span>
      </div>
    </div>
    <div class="block receive_info">
      <h2>
        {{$t('mall_confirm_order.receiver')}}<!-- 取貨人信息 -->
      </h2>
      <div class="rowDiv" style="display: flex;">
        <div class="row">
          <span class="left">
            {{$t('mall_confirm_order.surname')}}<!-- 姓氏 -->
          </span>
          <input class="forename right" :placeholder="$t('mall_confirm_order.input_surname')" v-model="createOrderData.picker_customer.forename">
          <dd style="width: 4%;"></dd>
        </div>
        <div class="row">
          <dd style="width: 4%;"></dd>
          <span class="left">
            {{$t('mall_confirm_order.email')}}<!-- 郵箱 -->
          </span>
          <input class="email right" :placeholder="$t('mall_confirm_order.input_email')" v-model="createOrderData.picker_customer.email">
        </div>
        <div class="row">
          <span class="left">
           {{$t('mall_confirm_order.given_name')}} <!-- 名字 -->
          </span>
          <input class="surname right" :placeholder="$t('mall_confirm_order.input_name')" v-model="createOrderData.picker_customer.surname">
          <dd style="width: 4%;"></dd>
        </div>
        <div class="row">
          <dd style="width: 4%;"></dd>
          <!--<span class="mobile left">電話</span>-->
          <select class="left" v-model="createOrderData.picker_customer.area_code"
                  style="letter-spacing:0; border-radius: 0 !important;">
            <option v-for="row in areaCodeList" :label="row.label" :value="row.value">{{row.label}}</option>
          </select>
          <input class="mobile right" :placeholder="$t('mall_confirm_order.input_phone')" v-model="createOrderData.picker_customer.phone">
        </div>
        <div class="row" v-show="shipping_type === 'YJ'" style="width: 100% !important;">
          <input class="deal_site right" :placeholder="$t('mall_confirm_order.zt_address')" v-model="createOrderData.picker_customer.deal_site"></input>
        </div>
      </div>
    </div>
    <div v-show="shipping_type === 'MD'" id="store" class="block storeDiv">
      <div class="store" :class="{ 'storeSelected': store_selected === row }"
           v-for="(row, index) in orderInfo.store_address" :key="index">
        <h2>{{row.name}}</h2>
        <div>
          <div class="left">
            <span>{{row.business_time}}</span>
            <span>{{row.address}}</span>
            <span>{{row.mobile}}</span>
          </div>
          <div class="right">
            <img
              :src="(store_selected === row) ? require('@/assets/img/order/ico_store_selected.png') : require('@/assets/img/order/ico_store.png')"
              @click="storeSelected(row)">
          </div>
        </div>
      </div>
    </div>
    <div class="block addressDiv" v-show="shipping_type === 'ZR'">
      <h2>
        {{$t('mall_confirm_order.ship_way')}}<!-- 送貨地址 -->
      </h2>
      <div>
        <div :class="{ 'edit_address': edit_address === row }" v-for="(row, index) in addresses" :key="index">
          <div class="address">
            <span style="padding: 20px 0"><img
              :src="(address_selected === row) ? require('@/assets/img/order/ico_address_selected.png') : require('@/assets/img/order/ico_address.png')"
              @click="addressSelected(row)"></span>
            <span>{{row.name}} {{row.mobile}} <br> {{row.address_pca}} {{row.address}}</span>
            <span style="padding: 20px 0">
                 <img :src="require('@/assets/img/order/address_edit.png')" @click="addressEdit(row)">
                 <img :src="require('@/assets/img/order/address_delete.png')" @click="addressDelete(row)">
               </span>
          </div>
          <transition name="draw">
            <address-form
              :key="Math.random()"
              v-show="edit_address === row"
              :type="'edit'"
              :addressForm="edit_address"
              :areaList="areaList"
              :areaCodeList="areaCodeList"
              v-on:cancel="edit_address = null"
              v-on:reload="getMyAddress"></address-form>
          </transition>
        </div>

        <div class="address addressAdd">
               <span>
                 <img :src="require('@/assets/img/order/address_add.png')">
               </span>
          <span @click="addressAdd"><span style="cursor: pointer;">
            {{$t('mall_confirm_order.add_address')}}<!-- 新增地址 -->
          </span></span>
          <span></span>
        </div>
        <transition name="draw">
          <address-form
            :key="Math.random()"
            v-show="add_address"
            :type="'add'"
            :addressForm="address_form"
            :areaList="areaList"
            :areaCodeList="areaCodeList"
            v-on:cancel="add_address = false"
            v-on:reload="getMyAddress"></address-form>
        </transition>

      </div> <!-- 送货地址 舍弃 -->
    </div>
    <div class="block orderList">
      <h2>
        {{$t('mall_confirm_order.order_detail')}}<!-- 訂單明細 -->
      </h2>
      <divider style="margin-top: 10px;"></divider>
      <div style="padding: 20px 0">
        <div class="product" :class="{ 'dividerNone': index + 1 === orderInfo.product_model.length }"
             v-for="(row,index) in orderInfo.product_model"
             :key="index">
          <div class="orderImgDiv">
            <div class="orderImg">
              <img :src="imgUrl + row.path + '?x-oss-process=image/resize,m_fill,h_160,w_160'" alt="">
            </div>
          </div>
          <div class="orderDetail" ref="orderDetail">
            <div class="name">
              <span>{{row.default_name}}</span>
              <!--<span class="count">1px</span>-->
            </div>
            <div class="orderRight">
              <div class="orderInf">
                <div><span>
                  {{$t('mall_detail.color')}} : <!-- 顏色 -->
                </span><span> {{row.color_photo[0].color.name}}</span></div>
                <div><span>
                  {{$t('mall_detail.size')}} : <!-- 尺寸 -->
                </span><span> {{row.product_size ? row.product_size : $t('mall_detail.free_size')}}</span></div>
              </div>
              <div class="price priceFamily">${{row.areas[0].price | PriceFormat}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="unitPrice">
        <div>
          <div>
            {{$t('mall_confirm_order.subtotal')}}<!-- 小計 -->
          </div>
          <div class="priceFamily">${{orderInfo.total_price | PriceFormat}}</div>
        </div>
        <div>
          <div>
            {{$t('mall_confirm_order.shipping')}}<!-- 配送 -->
          </div>
          <div class="priceFamily">$0.00</div>
        </div>
      </div>
      <div class="other">
        <h3><span class="pointer" @click="couponButton">
          {{$t('mall_confirm_order.user_coupon')}}<!-- 優惠券使用 -->
          <img :src="require('@/assets/img/order/ico_other.png')" alt=""></span></h3>
        <div v-show="useCoupon" :class="{ 'priceChange': priceChange }">
          <input class="couponCode" @keyup.enter="useCouponCode" :placeholder="$t('mall_confirm_order.input_code')"
                 v-model="couponCode.coupon_code">
          <el-button @click="useCouponCode">
            {{$t('mall_confirm_order.submit')}}<!-- 提交 -->
          </el-button>
          <span class="priceFamily price">- $<span>{{ couponCode.price | PriceFormat }}</span></span>
        </div>
      </div>
      <div class="other">
        <h3><span @click="remarks">
          {{$t('mall_confirm_order.remarks')}}<!-- 訂單備註 -->
          <img :src="require('@/assets/img/order/ico_other.png')" alt=""></span></h3>
        <div v-show="isShowRemarks"><input v-model="createOrderData.customer_remarks" :placeholder="$t('mall_confirm_order.input_remarks')"
                                           style="width: 100%"></div>
      </div>
      <div class="totalAmount">
        <div>
        {{$t('mall_confirm_order.total')}}<!-- 總價 -->
        </div>
        <div>${{orderInfo.total_price - couponCode.price | PriceFormat}}</div>
      </div>
      <div class="paymentTerms">
        <div>
          {{$t('mall_confirm_order.support')}}：<!-- 支持 --></div>
        <div class="displayR termsBox">
          <div class="terms">
            <img style="width: 129px;height: 33px;" :src="require('@/assets/img/order/ico_pay_visa_master_card.png')" alt="">
          </div>
          <div class="displayR btnsBox">
            <div>
              <router-link to="/search/list?type=reco">
               {{$t('mall_confirm_order.continue_shopping')}}<!-- 繼續購物 -->
              </router-link>
            </div>
            <div class="submit" @click="createOrder" v-loading.fullscreen.lock="loading">
              {{$t('mall_confirm_order.submit_order')}}<!-- 提交訂單 -->
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Validator from '@/assets/js/Validator';
  import PriceFormat from '@/assets/js/PriceFormat';
  import ElSelectDropdown from "element-ui/packages/select/src/select-dropdown";
  import AddressForm from "@/components/AddressForm";
  import Divider from "../../../components/Divider";
  import baseUrl from '@/api/baseUrl.js'
  import PayOrder from "./PayOrder";

  export default {
    name: "ConfirmOrder",
    beforeRouteEnter(to, from, next) {
      var token = localStorage.getItem('Authorization');
      // console.log("this.$store.token",  localStorage.getItem('Authorization'));
      if (token !== null && token !== "") {
        next()
      } else {
        next('/login');
      }
    },
    components: {
      Divider,
      ElSelectDropdown,
      AddressForm
    },
    data() {
      return {
        useCoupon: false,
        priceChange: false,
        couponCode: {
          name: '',
          coupon_code: '',
          price: 0,
        },
        loading: false,
        areaCodeList: [
          {value: '852', label: '+852'},
          {value: '86', label: '+86'}
        ],

        isShowRemarks:false,
        createOrderData: {
          customer_address_id: '',
          products: [
            {
              product_model_id: '',
              product_color_id: '',
              product_size: '',
            }
          ],
          shipping_method_id: 0,
          payments: {},
          store_id: '',
          picker_customer: {
            forename: '',
            surname: '',
            email: '',
            area_code: '852',
            phone: '',
            deal_site: '',
          },
          customer_remarks: ''
        },
        imgUrl: baseUrl.imgUrl,
        orderInfo: {
          product_model: [],
          store_address: [],
        },
        store_selected: null,
        areaList: [],
        add_address: false,
        edit_address: null,
        address_form: {
          name: '',
          area_code: '852',
          mobile: '',
          email: '',
          address: ''
        },
        shipping_type: 'MD',
        shipping_type_id: { MD: 3, ZR: 1, YJ: 7 },
        address_selected: null,
        addresses: [],
      }
    },
    filters: {
      PriceFormat(val) {
        return PriceFormat(val);
      }
    },
    methods: {
      couponButton() {
        if (this.useCoupon) {
          this.couponCode = {
            name: '',
            coupon_code: '',
            price: 0
          }
        }
        this.useCoupon = !this.useCoupon;
      },
      remarks(){
        if (this. isShowRemarks){
          this.createOrderData.customer_remarks = '';
        }
        this.isShowRemarks=!this.isShowRemarks;
      },
      priceChangeActive() {
        this.priceChange = true;
        let that = this;
        setTimeout(function () {
          that.priceChange = false
        }, 400);
      },
      useCouponCode() {
        if (!this.couponCode.coupon_code) {
          this.$notify.warning({
            message: this.$t('mall_confirm_order.input_code')//'請輸入優惠碼'
          });
          $('.couponCode').focus();
        } else {
          this.couponCode = {name: '', coupon_code: this.couponCode.coupon_code, price: 0};
          this.createOrderData.payments = {};
          this.$axios.post('/api/app_v1/customer/coupon_code_pay', {
            coupon_code: this.couponCode.coupon_code,
            products: this.createOrderData.products
          }).then(res => {
            this.priceChangeActive();
            this.couponCode = Object.assign(this.couponCode, res.data.data);
            this.createOrderData.payments = {coupon_string: this.couponCode.id};
            this.$notify.success({
              message: this.couponCode.name
                ? this.couponCode.name
                : this.$t('mall_confirm_order.input_code')//'優惠減免'
            });
          })
        }
      },
      storeSelected(row) {
        this.store_selected = row;
        this.createOrderData.store_id = row.id;
      },
      shippingTypeChange(type) {
        if (!this.addressTime()) {
          this.edit_address = null;
          this.shipping_type = type;
          this.createOrderData.shipping_method_id = this.shipping_type_id[type];
        }
      },
      // addressSelected(row) {
      //   if (!this.addressTime()) {
      //     this.address_selected = row;
      //   }
      // },
      addressTime() {
        if (this.edit_address || this.add_address) {
          this.$notify.warning({
            message:this.$t('mall_confirm_order.address_tips') //'請先 完成/取消 當前的地址編輯'
          });
          return true;
        } else {
          return false;
        }
      },
      addressAdd() {
        if (this.edit_address) {
          this.$notify.warning({
            message: this.$t('mall_confirm_order.address_tips')//'請先 完成/取消 當前的地址編輯'
          });
        } else {
          this.add_address = !this.add_address;
        }
      },
      addressEdit(row) {
        if (this.edit_address === row) {
          this.edit_address = null;
        } else if (!this.addressTime()) {
          this.edit_address = row;
        }

      },
      addressDelete(row) {
        if (!this.addressTime()) {
          this.$confirm(this.$t('mall_confirm_order.true_del'), this.$t('mall_confirm_order.tips'), {
            type: 'warning'
          }).then(() => {
            this.$axios.delete('api/app_v1/customer/addresses/' + row.id).then(res => {
              this.$notify.success({
                message: this.$t('mall_cart.success_delete')//'刪除成功'
              });
              this.getMyAddress();
            });
          });
        }
      },
      getMyAddress() {
        this.edit_address = null;
        this.add_address = false;
        this.$axios.get('api/app_v1/customer/addresses', {}).then(res => {
          this.addresses = res.data.data;
          if (this.addresses.length > 1) {
            this.addresses.map(row => {
              if (row.is_default === 1) {
                this.address_selected = row;
              }
            })
          }
          if (this.addresses.length === 1) {
            this.address_selected = this.addresses[0];
          }
        });
      },
      getAreaList() {
        this.$axios.get('mall_api/city_list', {}).then(res => {
          this.areaList = res.data.data;
        });
      },
      getOrderInfo() {
        this.$axios.post('mall_api/trans/prepare_purchase_order_v2', this.createOrderData).then(res => {
          this.getMyAddress();
          this.getAreaList();
          this.orderInfo = res.data.data;
          this.orderInfo.product_model.map(row => {
            this.createOrderData.products.map(search => {
              if (search.product_model_id == row.id) {
                row.product_size = search.product_size;
              }
            })
          })
        });
      },
      createOrder() {
        this.shippingTypeChange(this.shipping_type);
        if (this.orderValidator()) {
          this.loading = true;
          this.$axios.post('/mall_api/trans/purchase_v2', this.createOrderData).then(res => {
            this.$notify.success({
              message: this.$t('mall_confirm_order.create_order')//'創建訂單成功'
            });
            let that = this;
            setTimeout(function () {
              that.$router.push({
                name: 'PayOrder',
              });
            }, 800);
          }).catch(err => {
            if (err.error.code === '54220') {
              this.$axios.get('api/app_v1/product/trans/pending_orders_v2').then(res => {
                let penddingOrderId = res.data.data.id;
                this.$router.push({
                  name: 'OrderDetail',
                  query: { id: penddingOrderId }
                })
              });
            }
            this.loading = false;
          });
        }
      },
      orderValidator() {
        if (this.shipping_type !== 'ZR') {
          if (!this.createOrderData.picker_customer.forename) {
            this.$notify.error({message:
                this.$t('mall_confirm_order.input_surname')//'請填寫姓氏'
            });
            $('.forename').focus();
            return false;
          }
          if (!this.createOrderData.picker_customer.surname) {
            $('.surname').focus();
            this.$notify.error({
              message:  this.$t('mall_confirm_order.input_name')//'請填寫名字'
            });
            return false;
          }
          if (!Validator('email', {email: this.createOrderData.picker_customer.email})) {
            return false;
          }
          if (!Validator('mobile', {
            mobile: this.createOrderData.picker_customer.phone,
            areaCode: this.createOrderData.picker_customer.area_code
          })) {
            return false;
          }
        }
        switch (this.shipping_type) {
          case 'MD':
            if (!this.createOrderData.store_id) {
              this.$notify.error({
                message: this.$t('mall_confirm_order.input_md')//'請選擇壹個門店'
              });
              document.getElementById('store').scrollIntoView();
              return false;
            }
            break;
          case 'ZR':
            if (!this.address_selected) {
              this.$notify.error({
                message: this.$t('mall_confirm_order.input_zr')//'請選擇壹個收貨地址'
              });
              return false;
            }
            this.createOrderData.customer_address_id = this.address_selected.id;
            break;
          case 'YJ':
            if (!this.createOrderData.picker_customer.deal_site) {
              $('.deal_site').focus();
              this.$notify.error({
                message: this.$t('mall_confirm_order.input_zj')//'請填寫交收地點'
              });
              return false;
            }
            break;
          default:
            return false;
        }
        return true;
      },
      productFormatCheck() {
        let products = this.$route.query.products;
        new Promise(function (resolve, reject) {
          products = JSON.parse(products)
          resolve(products);
        });
        if (products instanceof Array) {
          let keyArray = ['product_model_id', 'product_color_id', 'product_size'];
          products.forEach(product => {
            for (let key in product) {
              if (keyArray.indexOf(key) < 0) {
                this.$router.replace({name: 'NotFound'});
              }
            }
            let regString = /[a-zA-Z]+/;
            if (regString.test(product.product_model_id)
              || regString.test(product.product_color_id)
              || (product.product_size && product.product_size.length > 10)) {
              this.$router.push({name: 'NotFound'});
            }
          });
          this.createOrderData.products = products;
          return true;
        }
        this.$router.replace({name: 'NotFound'});
      },
      getUserInfo() {
        this.$axios.get('mall_api/customer_info').then(res => {
          this.createOrderData.picker_customer.forename = res.data.data.first_name;
          this.createOrderData.picker_customer.surname = res.data.data.last_name;
          this.createOrderData.picker_customer.email = res.data.data.email;
          this.createOrderData.picker_customer.phone = res.data.data.mobile;
          this.createOrderData.picker_customer.area_code = res.data.data.area_code;
          // console.log(this.picker_customer)
        });
      }
    },
    mounted() {
    },
    created() {
      this.$parent.changeTab(1);
      if (this.productFormatCheck()) {
        this.getOrderInfo();
        this.getUserInfo();
      }
    },
  }
</script>

<style lang="less" scoped>
  h2 {
    font-size: 20px;
    color: #1E1303;
    font-weight: 500;
  }

  .block {
    margin-bottom: 30px;
  }

  .orderList {

  }

  .orderList .product {
    display: flex;
    flex-direction: row;

  }

  .orderImgDiv {
    margin-right: 20px;
    padding: 20px 0;
  }

  .orderImg {
    width: 180px;
    height: 180px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    padding: 10px;
  }

  .orderImg > img {
    width: 100%;
  }

  .orderDetail {
    color: #979694;
    font-size: 16px;
    width: 100%;
    padding: 20px 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
  }

  .dividerNone .orderDetail {
    border-bottom: none
  }

  .name {
    color: #5B5957;
    font-size: 16px;
    padding-bottom: 30px;
    padding-top: 10px;
  }

  .count {
    color: #979694;
    font-size: 16px;
  }

  .orderRight {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .price {
    color: #3E3C39;
    font-size: 18px;
  }

  .priceFamily {
    font-family: STSong !important;
  }

  .shippingSelect {
    width: 100%;
    overflow: hidden;
  }

  .shippingDiv {
    cursor: pointer;
    box-sizing: border-box;
    padding-top: 30px;
    width: 48%;
    height: 200px;
    text-align: center;
  }

  .shippingDiv span {
    margin: 0 auto;
    display: block;
    color: rgba(30, 19, 3, 1);
  }

  .shippingDiv span:nth-child(1) {
    width: 68px;
    height: 68px;
  }

  .shippingDiv span:nth-child(2) {
    font-size: 34px;
    font-weight: 400;
  }

  .shippingDiv span:nth-child(3) {
    font-size: 16px;
    font-weight: 300;
  }

  .shippingDiv span > img {
    max-width: 70px;
    max-height: 60px;
  }

  .shipping_md {
    float: left;
  }

  .shipping_yj {
    float: right;
  }

  .shippingDiv {
    background: #FFF;
    border: 1px solid #DDDDDD;
  }

  .shipping_selected, .shippingDiv:hover {
    background: #F7E7BC;
    border: 1px solid #DFBB7A;
  }

  .receive_info {

  }

  .rowDiv {
    flex-wrap: wrap;
  }

  .receive_info .row {
    width: 50%;
  }

  .row {
    display: flex;
    color: #1E1303;
    margin: 9px 0 6px 0;
  }

  .row .left {
    font-size: 15px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(231, 231, 231, 1);
    padding: 10px 10px;
    box-sizing: border-box;
    width: 82px;
    letter-spacing: 0px;
    text-align: center;
    margin-right: 5px;
  }

  .row .right {
    font-size: 15px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(231, 231, 231, 1);
    padding: 10px 10px;
    box-sizing: border-box;
    flex: 1;
  }

  .address {
    display: flex;
    padding: 15px 0;
  }

  .address:hover {
    opacity: 0.8;
  }

  .address span img {
    cursor: pointer;
  }

  .address span:nth-child(1) {
    flex: 1;
  }

  .address span:nth-child(1) > img {
    width: 23px;
    height: 23px;
  }

  .address span:nth-child(2) {
    flex: 12;
    font-size: 20px;
    color: rgba(30, 19, 3, 1);
    height: 56px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .address span:nth-child(3) {
    flex: 2;
    text-align: right;
  }

  .address span:nth-child(3) > img {
    width: 21px;
    height: 21px;
  }

  .address span:nth-child(3) img:nth-child(1) {
    margin-right: 22px;
  }

  .addressAdd {
    height: 28px
  }

  .addressAdd span:nth-child(1) > img {
    padding: 2px;
  }

  .addressAdd span:nth-child(2) {
    height: 28px;
    color: #979694 !important;
  }

  .draw-enter-active, .draw-leave-active {
    transition: all .3s;
  }

  .draw-enter, .draw-leave-to {
    opacity: 0;
  }

  .formZR .row {
    width: 100%;
  }

  .formZR .el-button {
    border-radius: 0;
    height: 52px;
    font-size: 20px;
  }

  .formZR .saveAddressButton {
    background: rgba(231, 204, 152, 1);
    color: #FFFFFF;
  }

  .formZR .cancelAddressButton {
    color: #635C50;
  }

  .orderInf > div {
    margin-bottom: 10px;
  }

  .totalAmount {
    color: #5B5957;
    font-size: 20px;
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    padding: 25px 0;
    margin-bottom: 20px;
    /*border-bottom: 1px solid #ddd;*/
  }

  .unitPrice {
    flex-direction: column !important;
    padding: 20px 0;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    font-size: 16px;
  }

  .unitPrice > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .paymentTerms {
    font-size: 16px;
    display: flex;
    flex-direction: column !important;
  }

  .termsBox {
    justify-content: space-between;
    margin-top: 10px;
  }

  .btnsBox div {
    cursor: pointer;
    display: inline-block;
    width: 120px;
    padding: 12px 0;
    border: 1px solid #1E1303;
    margin-right: 20px;
    text-align: center;
  }

  .btnsBox div > a {
    display: block;
  }

  .submit {
    background-color: #1E1303;
    color: #fff;
  }

  .edit_address .address {
    opacity: 0.5;
    padding-bottom: 0;
  }

  .edit_address .formZR {
    margin-top: -16px;
  }

  .storeDiv {
    font-size: 20px;
  }

  .storeDiv > div {
    padding: 20px 0;
  }

  .storeDiv > div:hover, .storeSelected {
    opacity: 0.8;
  }

  .storeDiv > div h2 {
  }

  .storeDiv > div > div {
    display: flex;
  }

  .storeDiv > div > div .left {
    flex: 1;
  }

  .storeDiv > div > div .right {
    display: flex;
    align-items: center;
  }

  .storeDiv > div > div .left span {
    display: block;
  }

  .storeDiv > div > div .right > img {
    cursor: pointer;
  }

  .other {
    cursor: pointer;
    padding: 15px 0;
  }

  .other h3 {
    font-size: 16px;
    color: rgba(30, 19, 3, 1);
    font-weight: 400;
    display: flex;
  }

  .other h3 span {
    display: flex;
  }

  .other h3 img {
    padding: 7px;
  }

  .other > div {
    margin: 20px 0 5px 0;
    height: 40px;
    display: flex;
  }

  .other > div > input {
    padding-left: 5px;
    width: 163px;
    height: 100%;
    border: 1px solid rgba(187, 187, 187, 1);
    box-sizing: border-box;
    font-size: 16px;
  }

  .other > div > button {
    width: 82px;
    height: 40px;
    color: white;
    background: rgba(231, 204, 152, 1);
    border: none;
    border-radius: unset;
    margin-left: 2px;
  }

  .other > div > button:hover {
    opacity: 0.8;
  }

  .other > div .price {
    padding: 12px 0;
    font-size: 16px;
    text-align: right;
    flex: 1;
  }

  .priceChange {
    background-color: rgba(231, 204, 152, 0.11);
    transition: all .4s;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Order/ConfirmOrder.vue